import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import css from '../index.module.css';

interface Props {
  headerText: string;
  tooltipId: string;
  tooltipText: string;
  isRequired?: boolean;
}

export function TableHeader({
  headerText,
  tooltipId,
  tooltipText,
  isRequired = false,
}: Props) {
  return (
    <div data-tip data-for={tooltipId} className={css['table-header']}>
      <span className={`${isRequired ? css['required'] : ''}`}>
        {headerText}
      </span>
      <FontAwesomeIcon icon={faQuestionCircle} />

      <ReactTooltip
        id={tooltipId}
        backgroundColor={'#002A58'}
        place="top"
        effect="solid"
      >
        <Trans i18nKey={tooltipText} components={{ 1: <br /> }} />
      </ReactTooltip>
    </div>
  );
}
